import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogDescription,
} from "./ui/dialog";
import { Check } from "lucide-react";

/**
 * Big, centered "next step" confirmation modal — the same visual pattern as
 * the "Request sent!" panel inside ItemDetailModal, promoted into a
 * reusable dialog so every rental-lifecycle action (accept, decline,
 * cancel, mark returned, accept return, release/withhold deposit, publish
 * listing, etc.) can show consistent, unmissable next-step guidance
 * instead of just a bottom-right toast.
 *
 * Usage:
 *   const [step, setStep] = useState(null);
 *   ...
 *   setStep({ title: "Request accepted",
 *             description: "…",
 *             actionLabel: "Got it" });
 *   ...
 *   <NextStepDialog step={step} onClose={() => setStep(null)} />
 */
export const NextStepDialog = ({ step, onClose }) => {
    return (
        <Dialog open={!!step} onOpenChange={(v) => !v && onClose?.()}>
            <DialogContent
                data-testid="next-step-dialog"
                className="max-w-md rounded-3xl border border-[#2e3220]/10 bg-[#F4F1EA] p-0 text-[#2e3220]"
            >
                <div className="p-6 text-center">
                    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#737a3d] text-[#F4F1EA]">
                        <Check className="h-7 w-7" strokeWidth={2.5} />
                    </div>
                    <DialogTitle
                        className="font-display text-2xl font-bold text-[#2e3220]"
                        data-testid="next-step-title"
                    >
                        {step?.title}
                    </DialogTitle>
                    <DialogDescription
                        className="mt-3 text-sm leading-relaxed text-[#5a6142]"
                        data-testid="next-step-description"
                    >
                        {step?.description}
                    </DialogDescription>
                    <button
                        type="button"
                        onClick={onClose}
                        data-testid="next-step-done"
                        className="btn-primary mt-6 !py-2.5 !px-8 text-sm"
                    >
                        {step?.actionLabel || "Got it"}
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default NextStepDialog;
